import { render } from "./Governance  Policy.vue?vue&type=template&id=0d9bc57a&scoped=true"
const script = {}

import "./Governance  Policy.vue?vue&type=style&index=0&id=0d9bc57a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d9bc57a"]])

export default __exports__